import { render } from "./UserMessagesView.vue?vue&type=template&id=bf7c501c&scoped=true"
import script from "./UserMessagesView.vue?vue&type=script&lang=js"
export * from "./UserMessagesView.vue?vue&type=script&lang=js"

import "./UserMessagesView.vue?vue&type=style&index=0&id=bf7c501c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf7c501c"]])

export default __exports__